import React from 'react';
import './FaceView.scss';
import { connect } from 'react-redux';
import PageHelper from 'Flow2/components/Article/Helpers/PageHelper';
import CustomPopUp from 'Flow2/components/Article/Utilities/PopUp/PopUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { faImage, faSmile, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import * as ShareTypes from 'Flow2/components/Share/ShareTypes/ShareTypes';
import * as actions from "store/actions/index";
import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import FaceSubjects from 'Flow2/components/Ai/Faces/FaceSubjects/FaceSubjects';
import FaceList from 'Flow2/components/Ai/Faces/FaceList/FaceList';
import FaceEdit from 'Flow2/components/Ai/Faces/FaceEdit/FaceEdit';
import FaceDelete from 'Flow2/components/Ai/Faces/FaceDelete/FaceDelete';
import FaceAdd from 'Flow2/components/Ai/Faces/FaceAdd/FaceAdd';
import FaceUpload from 'Flow2/components/Ai/Faces/FaceUpload/FaceUpload';

class FaceView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            popUpObjects: {},
            requiredObj: {},
            data: [],
            currentImages: [],
            current: {},
            subjects: []
        }
    }

    getBodyClasses = () => "custom-body custom-mt10";

    onCloseBtnClick = () => {
        const { faceSubjects } = this.props.faceObjects;
        this.props.updatePopUpObjects({
            [`${this.props.subObjName}`]: { ...faceSubjects, showOverlay: false },
            showPreview: false
        });

        if (this.props.cancelCallback) this.props.cancelCallback();
    }

    onEditClick = (subject) => {
        const { faceEdit } = this.props.faceObjects;
        this.props.updateFaceObjects({
            faceEdit: { ...faceEdit, showOverlay: true },
            showEditBox: true
        });
        this.setState({ showEditBox: true });
        this.initData(subject);
    }

    onDeleteClick = (subject) => {
        const { faceDelete } = this.props.faceObjects;
        this.props.updateFaceObjects({
            faceDelete: { ...faceDelete, showOverlay: true },
            showDeleteBox: true
        });
        this.setState({ showDeleteBox: true });
        this.initData(subject);
    }

    onAddClick = () => {
        const { faceAdd } = this.props.faceObjects;
        this.props.updateFaceObjects({
            faceAdd: { ...faceAdd, showOverlay: true },
            showEditBox: true
        });
        this.setState({ showAddBox: true });
    }

    isNotEmpty = () => {
        const { faceSubjects } = this.props.faceObjects;
        if (faceSubjects && faceSubjects.subjects && faceSubjects.subjects.length) return true;
        return false;
    }

    initData = (subject = null) => {
        const { faceSubjects, faceCollections, faceCurrent } = this.props.faceObjects;
        if (this.isNotEmpty()) {
            let current;
            if (subject) current = faceSubjects.subjects.find(item => item.id === subject.id);
            else if (faceCurrent) current = faceSubjects.subjects.find(item => item.subject === faceCurrent.subject);
            else current = faceSubjects.subjects[0];

            if (current) {
                let currentImages = [];
                if (faceCollections && faceCollections.faces) {
                    currentImages = faceCollections.faces.filter(item => item.subject === current.subject)
                }
                this.setState({
                    currentImages, current,
                    currentImgCount: currentImages.length,
                    subjects: faceSubjects.subjects
                });

                if (current.subject != faceCurrent.subject) {
                    this.props.updateFaceObjects({ faceCurrent: current });
                }
            }
        }
    }

    onSearchChange = (e) => {
        const { value } = e.target;
        const { faceSubjects } = this.props.faceObjects;
        this.setState({ searchTerm: value }, () => {
            let subjects = faceSubjects.subjects
                .filter(item => item.subject.toLowerCase().includes(value.toLowerCase()));
            this.setState({ subjects });
        });
    }

    onSelectFace = (subject) => {
        this.initData(subject);
    }

    onDeleteFace = (subject) => {
        if (subject && subject.image_id) {
            this.props.deleteImgFromCollection({ imageId: subject.image_id, subject });
        }
    }

    showContentTop = () => {
        return (
            <div className="faceview-content-top-box">
                <h3> {this.props.intl.formatMessage({ id: "faceview.heading" })}</h3>
                <div className="faceview-content-search">
                    <input type="text" value={this.state.searchTerm} onChange={this.onSearchChange}
                        placeholder={this.props.intl.formatMessage({ id: "faceview.search" })} />
                    <div className="faceview-content-search-icon">
                        <FontAwesomeIcon icon={faSearch} />
                    </div>
                </div>
            </div>
        )
    }

    showContentLeft = () => {
        return (
            <>
                <div className="faceview-content-left-top">
                    {(this.isNotEmpty()) && (
                        <FaceSubjects fallbackText="Loading..." subjects={this.state.subjects}
                            onSelectFace={this.onSelectFace} onDeleteClick={this.onDeleteClick}
                            current={this.state.current}
                            onEditClick={this.onEditClick} />
                    )}
                </div>
                <div className="faceview-content-left-bottom">
                    <div className="custom-btn custom-btn-active faceview-btn" onClick={this.onAddClick}>
                        <span className="faceview-icon">
                            <FontAwesomeIcon icon={faPlus} />
                        </span>
                        <span>
                            {this.props.intl.formatMessage({ id: "data.face.add.subject" })}
                        </span>
                    </div>
                    {this.state.showAddBox
                        ? <FaceAdd titleIntl="data.face.add" data={this.props.data}
                            mainObj={this.props.faceObjects} mainObjName="faceObjects" subObjName="faceAdd"
                            updatePopUpObjects={this.props.updateFaceObjects} />
                        : <div />}
                </div>
            </>
        )
    }

    showContentRight = () => {
        return (
            <>
                <div className="faceview-content-right-box">
                    <h3>{this.state.current.subject && this.state.current.subject}</h3>
                    <p>
                        {`${this.state.currentImgCount ? this.state.currentImgCount : 0} `}
                        {this.props.intl.formatMessage({ id: "faceview.images" })}
                    </p>
                </div>
                <div className="faceview-upload-box">
                    <FaceUpload updateObjects={this.props.faceUploadStart}
                        current={this.state.current}
                        addImgToSubject={this.props.addImgToSubject} />
                </div>
                {(this.isNotEmpty()) && (
                    <FaceList fallbackText="Loading..." faces={this.state.currentImages}
                        onSelectFace={this.onSelectFace} onDeleteFace={this.onDeleteFace} />
                )}
            </>
        )
    }

    showFaceView = () => {
        return (
            <div className="faceview-box">
                <div className="faceview-content-top">
                    {this.showContentTop()}
                </div>
                <div className="faceview-content">
                    <div className="faceview-content-left">
                        {this.showContentLeft()}
                    </div>
                    <div className="faceview-content-right">
                        {this.showContentRight()}
                    </div>
                </div>
            </div>
        )
    }


    displayPopUp = () => {
        return (<CustomPopUp titleIntl={this.props.titleIntl} popUpType={ShareTypes.MODALTYPE}
            contentItems={this.state.data} requiredObj={this.state.requiredObj} customIcon={faSmile}
            mainObj={this.props.faceObjects} mainObjName={this.props.mainObjName} subObjName={this.props.subObjName}
            updatePopUpObjects={this.props.updateFaceObjects} cancelCallback={this.onCloseBtnClick}
            confirmCallback={() => { }} onlyTest={true}>
            {this.showFaceView()}
        </CustomPopUp>)
    }

    showFooter = () => {
        return (
            <div className="custom-footer" onClick={this.closePopUp("faces")}>
                <FontAwesomeIcon icon={faImage} />
            </div>)
    }

    componentDidUpdate = (prev) => {
        const { faceSubjects, faceCollections } = this.props.faceObjects;
        if ((prev.faceObjects.faceSubjects != faceSubjects)
            || (prev.faceObjects.faceCollections != faceCollections)) {
            this.initData();
        }
    }

    componentDidMount = () => {
        this.initData();
    }

    render() {
        return (
            <div className="FaceView" onClick={PageHelper.onPopUpClick}>
                {this.props.mainObj[`${this.props.subObjName}`].showOverlay ?
                    <div className="custom-overlay">
                        <div className="custom-preview">
                            {this.props.loading ?
                                <div className="custom-spinner-overlay"><Spinner /></div>
                                : <div />}
                            {this.displayPopUp()}
                        </div>
                    </div> : null}

                {this.state.showEditBox
                    ? <FaceEdit titleIntl="data.share.face.edit" data={this.props.data} current={this.state.current}
                        mainObj={this.props.faceObjects} mainObjName="faceObjects" subObjName="faceEdit"
                        updatePopUpObjects={this.props.updateFaceObjects} />
                    : <div />}
                {this.state.showDeleteBox
                    ? <FaceDelete titleIntl="data.face.delete" data={this.props.data} current={this.state.current}
                        mainObj={this.props.faceObjects} mainObjName="faceObjects" subObjName="faceDelete"
                        updatePopUpObjects={this.props.updateFaceObjects} />
                    : <div />}
            </div>
        );
    }
}

const mapStateToprops = (state) => ({
    faceObjects: state.face.faceObjects,
    faceUploadObjects: state.face.faceUploadObjects,
    loading: state.face.loading
})
const mapDispatchToProps = (dispatch) => ({
    updateFaceObjects: (obj) => dispatch(actions.updateFaceObjects(obj)),
    deleteSubject: (obj) => dispatch(actions.deleteSubject(obj)),
    faceUploadStart: (obj) => dispatch(actions.faceUploadStart(obj)),
    addImgToSubject: (obj) => dispatch(actions.addImgToSubject(obj)),
    deleteImgFromCollection: (obj) => dispatch(actions.deleteImgFromCollection(obj))
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FaceView));